import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import "../../../styles/Tms.css";
import { useAuth } from "../../../context/AuthContext";
import LoadingScreen from "../../../components/LoadingScreen";
import DenyAccessPage from "../../../components/DenyAccessPage";
import TmsNavbar from "../../../components/TmsNavbar";
import { fetchAuthorities, fetchUsers } from "../../../services/data";
import { assignTask } from "../../../services/tms";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faPlus } from "@fortawesome/free-solid-svg-icons";
import { fetchTeacherEmployeeDepartments, fetchWisdomRelatedOrganizations } from "services/wisdom/wisdomData";
import Popup from "components/Popup";

const WisdomTmsAddTask = () => {
    const location = useLocation();
    const { userInfo } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [auths, setAuths] = useState([]);
    const [selectedAuth, setSelectedAuth] = useState(null);
    const [locations, setLocations] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [showLocations, setShowLocations] = useState(false);
    const [orgs, setOrgs] = useState([]);
    const [filteredOrgs, setFilteredOrgs] = useState([]);
    const [selectedOrgs, setSelectedOrgs] = useState([]);
    const [showOrgs, setShowOrgs] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [filteredDepartments, setFilteredDepartments] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [showDepartments, setShowDepartments] = useState(false);
    const [users, setUsers] = useState([]);
    const [filteredAssignee, setFilteredAssignee] = useState([]);
    const [filteredReviewer, setFilteredReviewer] = useState([]);
    const [filteredManager, setFilteredManager] = useState([]);
    const [selectedAssignees, setSelectedAssignees] = useState([]);
    const [showAssignees, setShowAssignees] = useState(false);
    const [assigneeSearch, setAssigneeSearch] = useState("");
    const [selectedManager, setSelectedManager] = useState(null);
    const [selectedReviewer, setSelectedReviewer] = useState(null);
    const [selectedImportance, setSelectedImportance] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [taskDescription, setTaskDescription] = useState("");
    const [taskNotes, setTaskNotes] = useState("");
    const [taskTitle, setTaskTitle] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [timeFrom, setTimeFrom] = useState();
    const [timeTo, setTimeTo] = useState();
    const [taskCount, setTaskCount] = useState(0);
    const [tasks, setTasks] = useState([]);
    const [myTask, setMyTask] = useState(false);
    const [notAvailable, setNotAvailable] = useState(false);
    const [popupMessage, setPopupMessage] = useState();

    const navItem = (label, path) => (
        <button
            onClick={() => {
                navigate(path);
            }}
            className={`relative bg-transparent text-black rounded-none shadow-none border-none px-2 py-1 group`}
        >
            <span
                className="font-bold relative z-10
            after:content-['']
            after:absolute
            after:left-0
            after:-bottom-[3px]
            after:h-[3px]
            after:rounded
            after:w-full
            after:bg-watomsBlue
            after:transform
            after:scale-x-0
            after:origin-left
            after:transition-transform
            after:duration-300
            group-hover:after:scale-x-100
          "
            >
                {label}
            </span>
        </button>
    );

    const handleChange = (index, field, value) => {
        setTasks(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };

    useEffect(() => {
        const loadAllData = async () => {
            setLoading(true);
            try {
                const [authResponse, orgResponse, departmentResponse, usersResponse] = await Promise.all([
                    fetchAuthorities(),
                    fetchWisdomRelatedOrganizations(),
                    fetchTeacherEmployeeDepartments(),
                    fetchUsers(userInfo),
                ]);

                const filteredAuth = authResponse.filter(auth => auth.id !== 2 && auth.id !== 3 && auth.id !== 5)
                setAuths(filteredAuth);

                const filteredLocations = [...new Set(orgResponse.map(org => org.city))];
                setLocations(filteredLocations);

                // Filter orgs
                setOrgs(orgResponse);

                setDepartments(departmentResponse)
                setFilteredDepartments(departmentResponse)

                // Handle users
                setUsers(usersResponse);
                setFilteredAssignee(usersResponse);
                setFilteredReviewer(usersResponse);
                setFilteredManager(usersResponse);
            } catch (error) {
                console.error("Error loading data:", error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        loadAllData();
    }, [userInfo]);

    // filter locations
    useEffect(() => {
        const filterData = () => {
            setLocations([]);
            setSelectedLocations([]);
            const filteringOrgs = orgs.filter(org => Number(org.authority_id) === Number(selectedAuth));
            const filteredLocations = [...new Set(filteringOrgs.map(org => org.city))];
            setLocations(filteredLocations);
        };

        filterData();
    }, [selectedAuth])

    // filter organization
    useEffect(() => {
        const filterData = () => {
            const filteringOrgs = orgs.filter(org =>
                (selectedAuth === "" || Number(org.authority_id) === Number(selectedAuth)) &&
                (selectedLocations.length === 0 || selectedLocations.includes(org.city))
            );

            setFilteredOrgs(filteringOrgs);
        };

        filterData();
    }, [selectedAuth, selectedLocations]);

    useEffect(() => {
        const filterReviewers = () => {
            if (selectedOrgs.length > 0) {
                const filtered = users.filter(user =>
                    selectedOrgs.includes(user.employee.organization_id)
                );

                setFilteredReviewer(filtered);
                setFilteredManager(filtered);

                const departmentsMap = new Map();

                filtered.forEach(user => {
                    const employeeDepartmentId = user.employee?.department_id;
                    const teacherDepartmentId = user.employee?.teacher?.department_id;

                    if (employeeDepartmentId) {
                        departmentsMap.set(`employee-${employeeDepartmentId}`, {
                            id: employeeDepartmentId,
                            type: "employee",
                        });
                    }

                    if (teacherDepartmentId) {
                        departmentsMap.set(`teacher-${teacherDepartmentId}`, {
                            id: teacherDepartmentId,
                            type: "teacher",
                        });
                    }
                });

                const departmentIds = Array.from(departmentsMap.values());

                const filteringDepartments = departments.filter(department =>
                    departmentIds.some(
                        dep =>
                            dep.id === department.id &&
                            dep.type === department.type
                    )
                );

                setFilteredDepartments(filteringDepartments);
            } else if (myTask) {
                setFilteredManager(users);
                setFilteredReviewer(users);
            } else {
                setFilteredReviewer([]);
                setFilteredManager([]);
                setFilteredDepartments([]);
            }
        };

        filterReviewers();
    }, [selectedOrgs, users, departments, myTask]);

    useEffect(() => {
        const filterAssignee = () => {
            const filtered = users.filter(user => {
                const orgMatch =
                    selectedOrgs.length === 0 ||
                    selectedOrgs.includes(user.employee.organization_id);

                const departmentMatch =
                    selectedDepartments.length === 0 ||
                    selectedDepartments.some(department =>
                        (department.type === "employee" &&
                            user.employee.department_id === department.id) ||
                        (department.type === "teacher" &&
                            user.employee?.teacher?.department_id === department.id)
                    );

                return orgMatch && departmentMatch;
            });

            setFilteredAssignee(filtered);
        };

        filterAssignee();
    }, [selectedOrgs, selectedDepartments, users]);

    useEffect(() => {
        const changeTaskStatus = () => {
            if (myTask) {
                setSelectedAssignees([userInfo.id])
                setSelectedReviewer(userInfo.id)
                setSelectedManager(userInfo.id)
            } else {
                setSelectedAssignees([])
                setSelectedReviewer("")
                setSelectedManager("")
            }
        }

        changeTaskStatus();
    }, [myTask, userInfo])

    const submitingTask = async (e) => {
        e.preventDefault();
        if (!selectedOrgs || !selectedImportance || !selectedSize || !dateFrom || !dateTo || !selectedAssignees || !selectedManager || !selectedReviewer || !taskTitle) {
            toast.error('الرجاء مليء كل المطلوب')
            return
        }
        if (tasks.some(task => !task.title || !task.description || !task.end_date)) {
            toast.error("الرجاء مليء كل المطلوب");
            return;
        }
        try {
            const taskData = new FormData();
            taskData.append("task_details", JSON.stringify(tasks));
            taskData.append("title", taskTitle);
            taskData.append("description", taskDescription);
            taskData.append("note", taskNotes);
            taskData.append("start_date", new Date(`${dateFrom}T${timeFrom || "00:00"}`).toISOString());
            taskData.append("end_date", new Date(`${dateTo}T${timeTo || "00:00"}`).toISOString());
            taskData.append("importance", selectedImportance);
            taskData.append("size", selectedSize);
            taskData.append("assigner_id", userInfo?.id);
            taskData.append("assignee_id", JSON.stringify(selectedAssignees));
            taskData.append("reviewer_id", Number(selectedReviewer));
            taskData.append("manager_id", Number(selectedManager));
            taskData.append("organization_id", JSON.stringify(selectedOrgs));
            taskData.append("system", "wisdom");

            if (selectedFile) {
                taskData.append("file", selectedFile);
            }

            await assignTask(taskData);
            toast.success("تم تكليف المهمة");
            navigate("/wisdom/tms/my-tasks")
        } catch (err) {
            console.error("Error submitting data:", err);
            if (err.status === 409) {
                setPopupMessage("لقد تم تسجل هذه المهمة بالفعل لهذا المنفذ");
                setNotAvailable(true);
            }
        }
    }

    const handleLocationChange = (location) => {
        setSelectedLocations(prev =>
            prev.includes(location)
                ? prev.filter(l => l !== location)
                : [...prev, location]
        );
    };

    const handleSelectAll = () => {
        if (selectedLocations.length === locations.length) {
            setSelectedLocations([]);
        } else {
            setSelectedLocations([...locations]);
        }
    };

    const handleOrgChange = (orgId) => {
        setSelectedOrgs(prev =>
            prev.includes(orgId)
                ? prev.filter(id => id !== orgId)
                : [...prev, orgId]
        );
    };

    const handleSelectAllOrgs = () => {
        if (selectedOrgs.length === filteredOrgs.length) {
            setSelectedOrgs([]);
        } else {
            setSelectedOrgs(filteredOrgs.map(org => org.id));
        }
    };

    const searchedAssignees = filteredAssignee.filter(emp => {
        const fullName = `${emp?.employee?.employee_first_name} ${emp?.employee?.employee_middle_name} ${emp?.employee?.employee_last_name}`
            .toLowerCase();

        return fullName.includes(assigneeSearch.toLowerCase());
    });

    if (loading) return <LoadingScreen />;
    if (error?.status === 403) return <Navigate to="/login" state={{ from: location }} replace />;
    if (error) return <p>Error: {error.message}</p>;
    if (userInfo.user_role === "Student" || userInfo.user_role === "Trainee") return <DenyAccessPage homePage='/watoms/pms' />;
    if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
    if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
    if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;

    return (
        <div className="flex flex-col items-center w-full bg-gray-500 min-h-screen gap-2">
            <TmsNavbar
                shareStatus={false}
                searchStatus={false}
            >
                <div className={`hidden md:flex items-center gap-4 bg-gray-200 py-2 px-2 rounded-full shadow-lg shadow-black/30 w-fit`} >
                    {navItem("Dashboard", "/tms")}
                    {navItem("My Tasks", "/wisdom/tms/my-tasks")}
                </div>
            </TmsNavbar>
            <h1 className="text-2xl font-bold text-center text-yellow-400">اضافة مهام</h1>
            <form
                onSubmit={submitingTask}
                className="w-full flex flex-col gap-4 p-2"
            >

                {/* main content */}
                <div className="w-full flex flex-col gap-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* بيانات الجهة و التنفيذ */}
                        <div className="relative w-full bg-slate-600 rounded-xl p-4 shadow-md">
                            <div
                                onClick={() => setMyTask(prev => !prev)}
                                className={`absolute -top-3 -right-2 text-xl rounded-full w-6 h-6 flex justify-center items-center ${myTask ? "text-green-300 hover:text-green-400 bg-black" : "text-black bg-gray-300 hover:bg-gray-400"} cursor-pointer`}
                            >
                                <FontAwesomeIcon icon={faCircleCheck} />
                            </div>

                            <div className="bg-gradient-to-b from-gray-700 to-gray-800 text-white rounded-lg p-2 text-center font-bold">
                                بيانات الجهة و التنفيذ
                            </div>

                            <div className="grid grid-cols-2 gap-2 mt-3">
                                {/* المنطقة */}
                                <div className="relative">
                                    <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                        المنطقة
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => setShowLocations(!showLocations)}
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 bg-white text-center font-bold"
                                    >
                                        {selectedLocations.length === 0
                                            ? "اختر المنطقة"
                                            : selectedLocations.length === locations.length
                                                ? "كل المناطق"
                                                : `${selectedLocations.length} منطقة مختارة`}
                                    </button>

                                    {showLocations && (
                                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto" dir="rtl">

                                            {/* Select All */}
                                            <label className="flex items-center gap-2 p-2 border-b cursor-pointer hover:bg-gray-100">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedLocations.length === locations.length}
                                                    onChange={handleSelectAll}
                                                />
                                                <span>اختيار الكل</span>
                                            </label>

                                            {/* Locations */}
                                            {locations.map(location => (
                                                <label
                                                    key={location}
                                                    className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedLocations.includes(location)}
                                                        onChange={() => handleLocationChange(location)}
                                                    />
                                                    <span>{location}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* الجهة */}
                                <div>
                                    <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                        الجهة
                                    </div>
                                    <select
                                        className="w-full p-2 mt-2 rounded-lg border border-gray-300 bg-white text-center font-bold"
                                        defaultValue=""
                                        onChange={(e) => setSelectedAuth(e.target.value)}
                                    >
                                        <option value="" disabled>اختر الجهة</option>
                                        {auths.map(auth => (
                                            <option key={auth.id} value={auth.id}>{auth.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* الادراة / القسم */}
                                <div className="relative">
                                    <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                        الادارة / القسم
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => setShowDepartments(!showDepartments)}
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 bg-white text-center font-bold"
                                    >
                                        {selectedDepartments.length === 0
                                            ? "اختر الادارة او القسم"
                                            : selectedDepartments.length === filteredDepartments.length
                                                ? "كل الادارات / الاقسام"
                                                : `${selectedDepartments.length} مختار`}
                                    </button>

                                    {showDepartments && (
                                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto" dir="rtl">

                                            {/* Select All */}
                                            <label className="flex items-center gap-2 p-2 border-b cursor-pointer hover:bg-gray-100">
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        filteredDepartments.length > 0 &&
                                                        selectedDepartments.length === filteredDepartments.length
                                                    }
                                                    onChange={() => {
                                                        if (selectedDepartments.length === filteredDepartments.length) {
                                                            setSelectedDepartments([]);
                                                        } else {
                                                            setSelectedDepartments(
                                                                filteredDepartments.map(dep => ({
                                                                    id: dep.id,
                                                                    type: dep.type
                                                                }))
                                                            );
                                                        }
                                                    }}
                                                />
                                                <span>اختيار الكل</span>
                                            </label>

                                            {/* Departments */}
                                            {filteredDepartments.map(department => {
                                                const checked = selectedDepartments.some(
                                                    dep =>
                                                        dep.id === department.id &&
                                                        dep.type === department.type
                                                );

                                                return (
                                                    <label
                                                        key={`${department.type}-${department.id}`}
                                                        className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={checked}
                                                            onChange={() => {
                                                                if (checked) {
                                                                    setSelectedDepartments(prev =>
                                                                        prev.filter(
                                                                            dep =>
                                                                                !(
                                                                                    dep.id === department.id &&
                                                                                    dep.type === department.type
                                                                                )
                                                                        )
                                                                    );
                                                                } else {
                                                                    setSelectedDepartments(prev => [
                                                                        ...prev,
                                                                        {
                                                                            id: department.id,
                                                                            type: department.type
                                                                        }
                                                                    ]);
                                                                }
                                                            }}
                                                        />

                                                        <span>{department.name}</span>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>

                                {/* المؤسسة / المنشئة */}
                                <div className="relative">
                                    <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                        المؤسسة / المنشأة
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => setShowOrgs(!showOrgs)}
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 bg-white text-center font-bold"
                                    >
                                        {selectedOrgs.length === 0
                                            ? "اختر المؤسسة أو المنشأة"
                                            : selectedOrgs.length === filteredOrgs.length
                                                ? "كل المؤسسات"
                                                : `${selectedOrgs.length} مؤسسة مختارة`}
                                    </button>

                                    {showOrgs && (
                                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto" dir="rtl">

                                            <label className="flex items-center gap-2 p-2 border-b cursor-pointer hover:bg-gray-100">
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        filteredOrgs.length > 0 &&
                                                        selectedOrgs.length === filteredOrgs.length
                                                    }
                                                    onChange={handleSelectAllOrgs}
                                                />
                                                <span>اختيار الكل</span>
                                            </label>

                                            {filteredOrgs.map(org => (
                                                <label
                                                    key={org.id}
                                                    className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedOrgs.includes(org.id)}
                                                        onChange={() => handleOrgChange(org.id)}
                                                    />
                                                    <span>{org.name}</span>
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Assingee Selector */}
                            <div className="w-full mt-3 flex gap-2 relative">
                                <div className="w-[70%] relative">
                                    <button
                                        type="button"
                                        onClick={() => setShowAssignees(!showAssignees)}
                                        className="w-full p-3 rounded-lg border border-gray-300 bg-white text-center font-bold outline-none"
                                    >
                                        {selectedAssignees.length === 0
                                            ? "اختر المنفذ"
                                            : selectedAssignees.length === filteredAssignee.length
                                                ? "كل المنفذين"
                                                : `${selectedAssignees.length} منفذ مختار`}
                                    </button>

                                    {showAssignees && (
                                        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto" dir="rtl">

                                            <div className="sticky top-0 bg-white p-2 border-b">
                                                <input
                                                    type="text"
                                                    placeholder="ابحث عن منفذ..."
                                                    value={assigneeSearch}
                                                    onChange={(e) => setAssigneeSearch(e.target.value)}
                                                    className="w-full p-2 border rounded-lg text-center outline-none"
                                                />
                                            </div>

                                            <label className="flex items-center gap-2 p-2 border-b cursor-pointer hover:bg-gray-100">
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        searchedAssignees.length > 0 &&
                                                        searchedAssignees.every(emp =>
                                                            selectedAssignees.includes(emp.id)
                                                        )
                                                    }
                                                    onChange={() => {
                                                        const searchedIds = searchedAssignees.map(emp => emp.id);

                                                        if (
                                                            searchedAssignees.length > 0 &&
                                                            searchedAssignees.every(emp =>
                                                                selectedAssignees.includes(emp.id)
                                                            )
                                                        ) {
                                                            setSelectedAssignees(prev =>
                                                                prev.filter(id => !searchedIds.includes(id))
                                                            );
                                                        } else {
                                                            setSelectedAssignees(prev => [
                                                                ...new Set([...prev, ...searchedIds])
                                                            ]);
                                                        }
                                                    }}
                                                />
                                                <span>اختيار الكل</span>
                                            </label>

                                            {searchedAssignees.map(emp => {
                                                const checked = selectedAssignees.includes(emp.id);

                                                return (
                                                    <label
                                                        key={emp.id}
                                                        className="flex items-center gap-2 p-2 cursor-pointer hover:bg-gray-100"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={checked}
                                                            onChange={() => {
                                                                if (checked) {
                                                                    setSelectedAssignees(prev =>
                                                                        prev.filter(id => id !== emp.id)
                                                                    );
                                                                } else {
                                                                    setSelectedAssignees(prev => [...prev, emp.id]);
                                                                }
                                                            }}
                                                        />

                                                        <span>
                                                            {emp.employee.employee_first_name}{" "}
                                                            {emp.employee.employee_middle_name}{" "}
                                                            {emp.employee.employee_last_name}
                                                        </span>
                                                    </label>
                                                );
                                            })}

                                            {searchedAssignees.length === 0 && (
                                                <div className="p-3 text-center text-gray-500">
                                                    لا يوجد نتائج
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="w-[30%] text-white text-center text-sm flex justify-center items-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                    اسم المنفذ
                                </div>
                            </div>

                            <div className="w-full mt-3 flex gap-2">
                                <select
                                    className="w-[70%] p-3 rounded-lg border border-gray-300 bg-white text-center font-bold outline-none"
                                    defaultValue=""
                                    onChange={(e) => setSelectedReviewer(e.target.value)}
                                    value={selectedReviewer}
                                >
                                    <option value="" disabled>اختر المراجع</option>
                                    {filteredReviewer.map(emp => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.employee.employee_first_name} {emp.employee.employee_middle_name} {emp.employee.employee_last_name}
                                        </option>
                                    ))}
                                </select>
                                <div className="w-[30%] text-white text-center flex justify-center items-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                    اسم المراجع
                                </div>
                            </div>

                            <div className="w-full mt-3 flex gap-2">
                                <select
                                    className="w-[70%] p-3 rounded-lg border border-gray-300 bg-white text-center font-bold outline-none"
                                    defaultValue=""
                                    onChange={(e) => setSelectedManager(e.target.value)}
                                    value={selectedManager}
                                >
                                    <option value="" disabled>اختر المدير</option>
                                    {filteredManager.map(emp => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.employee.employee_first_name} {emp.employee.employee_middle_name} {emp.employee.employee_last_name}
                                        </option>
                                    ))}
                                </select>
                                <div className="w-[30%] text-white text-center flex justify-center items-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                    اسم المدير
                                </div>
                            </div>
                        </div>

                        {/* بيانات المهمة */}
                        <div className="relative w-full bg-slate-600 rounded-xl p-4 shadow-md">
                            <div
                                onClick={() => setTaskCount(prev => prev + 1)}
                                className="absolute -top-3 -right-2 text-xl rounded-full w-8 h-8 flex justify-center items-center bg-gray-300 hover:bg-gray-400 cursor-pointer"
                            >
                                <FontAwesomeIcon icon={faPlus} />
                            </div>
                            <div className="bg-gradient-to-b from-gray-700 to-gray-800 text-white rounded-lg p-2 text-center font-bold">
                                بيانات المهمة
                            </div>

                            {/* Title */}
                            <div className="gap-2 mt-3">
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                    اسم المهمة
                                </div>
                                <input
                                    type="text"
                                    className="w-full mt-2 rounded-lg border border-gray-300 text-center font-bold h-12"
                                    placeholder="أدخل عنوان المهمة هنا..."
                                    value={taskTitle || ""}
                                    onChange={(e) => setTaskTitle(e.target.value)}
                                />
                            </div>

                            {/* Description */}
                            <div className="gap-2 mt-3">
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                    وصف المهمة
                                </div>
                                <input
                                    type="text"
                                    className="w-full mt-2 rounded-lg border border-gray-300 text-center font-bold h-12"
                                    placeholder="أدخل وصف المهمة هنا..."
                                    value={taskDescription || ""}
                                    onChange={(e) => setTaskDescription(e.target.value)}
                                />
                            </div>

                            {/* Importance, Size and Attactement */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-3">
                                {/* Attacetment */}
                                <div>
                                    <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                        المرفقات
                                    </div>
                                    <input
                                        type="file"
                                        dir="rtl"
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 bg-white text-center font-bold"
                                        onChange={(e) => setSelectedFile(e.target.files[0])}
                                    />
                                </div>

                                {/* Size */}
                                <div>
                                    <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                        حجم المهمة
                                    </div>
                                    <select
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 bg-white text-center font-bold"
                                        defaultValue=""
                                        onChange={(e) => setSelectedSize(e.target.value)}
                                    >
                                        <option value="" disabled>اختر حجم المهمة</option>
                                        <option value="large">كبيرة</option>
                                        <option value="medium">وسط</option>
                                        <option value="small">صغيرة</option>
                                    </select>
                                </div>

                                {/* Priority */}
                                <div>
                                    <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                        الاولوية
                                    </div>
                                    <select
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 bg-white text-center font-bold"
                                        defaultValue=""
                                        onChange={(e) => setSelectedImportance(e.target.value)}
                                    >
                                        <option value="" disabled>اختر الأولوية</option>
                                        <option value="urgent">قصوى</option>
                                        <option value="important">مهمة</option>
                                        <option value="normal">عادية</option>
                                    </select>
                                </div>
                            </div>

                            {/* Notes */}
                            <div className="gap-2 mt-3">
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800">
                                    ملاحظات
                                </div>
                                <input
                                    type="text"
                                    className="w-full mt-2 rounded-lg border border-gray-300 text-center font-bold h-12"
                                    placeholder="أدخل ملاحظات المهمة هنا..."
                                    value={taskNotes || ""}
                                    onChange={(e) => setTaskNotes(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* التواريخ */}
                    <div className="w-full bg-slate-600 rounded-xl p-4 shadow-md">
                        <div className="bg-gradient-to-b from-gray-700 to-gray-800 text-white rounded-lg p-2 text-center font-bold">
                            التواريخ و التوقيت
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3">
                            <div>
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800  ">
                                    تاريخ و التوقيتات الانتهاء
                                </div>
                                <div className="flex gap-2">
                                    <input
                                        type="date"
                                        onChange={(e) => setDateTo(e.target.value)}
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 text-center font-bold"
                                    />
                                    <input
                                        type="time"
                                        onChange={(e) => setTimeTo(e.target.value)}
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 text-center font-bold"
                                    />
                                </div>
                            </div>

                            <div>
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-slate-700 to-slate-800  ">
                                    تاريخ و التوقيتات البدء
                                </div>
                                <div className="flex gap-2">
                                    <input
                                        type="date"
                                        onChange={(e) => setDateFrom(e.target.value)}
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 text-center font-bold"
                                    />
                                    <input
                                        type="time"
                                        onChange={(e) => setTimeFrom(e.target.value)}
                                        className="w-full p-3 mt-2 rounded-lg border border-gray-300 text-center font-bold"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* المهام الفرعية */}
                    {taskCount > 0 && (
                        <div className="bg-white rounded-xl p-4 shadow-md">
                            <div className="grid grid-cols-[15%_17.5%_45%_15%_5%] gap-2 mb-3">
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-gray-500 to-gray-600">
                                    تاريخ و توقيت الانتهاء
                                </div>
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-gray-500 to-gray-600">
                                    ملاحظات المهمة الفرعية
                                </div>
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-gray-500 to-gray-600">
                                    وصف المهمة الفرعية
                                </div>
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-gray-500 to-gray-600">
                                    عنوان المهمة الفرعية
                                </div>
                                <div className="text-white text-center rounded-lg p-2 bg-gradient-to-b from-gray-500 to-gray-600">
                                    مسلسل
                                </div>
                            </div>

                            {Array.from({ length: taskCount }, (_, i) => (
                                <div key={i} className="grid grid-cols-[15%_17.5%_45%_15%_5%] gap-2 mb-3">
                                    <div className="flex gap-2">
                                        <input
                                            type="date"
                                            onChange={(e) => {
                                                handleChange(i, "end_date", e.target.value);
                                                dateTo &&
                                                    dateTo < e.target.value &&
                                                    toast.error("الرجاء اختيار تاريخ صحيح") &&
                                                    handleChange(i, "end_date", "");
                                            }}
                                            className="w-1/2 text-[10px] p-2 rounded-lg border border-gray-300 text-center font-bold"
                                        />
                                        <input
                                            type="time"
                                            onChange={(e) => handleChange(i, "end_time", e.target.value)}
                                            className="w-1/2 text-[10px] p-2 rounded-lg border border-gray-300 text-center font-bold"
                                        />
                                    </div>

                                    <textarea
                                        className="w-full p-2 rounded-lg border border-gray-300 text-center font-bold h-12 resize-none"
                                        placeholder="أدخل ملاحظات المهمة هنا..."
                                        value={tasks[i]?.note || ""}
                                        onChange={(e) => handleChange(i, "note", e.target.value)}
                                    />

                                    <textarea
                                        className="w-full p-2 rounded-lg border border-gray-300 text-center font-bold h-12 resize-none"
                                        placeholder="أدخل وصف المهمة هنا..."
                                        value={tasks[i]?.description || ""}
                                        onChange={(e) => handleChange(i, "description", e.target.value)}
                                    />

                                    <textarea
                                        className="w-full p-2 rounded-lg border border-gray-300 text-center font-bold h-12 resize-none"
                                        placeholder="أدخل عنوان المهمة هنا..."
                                        value={tasks[i]?.title || ""}
                                        onChange={(e) => handleChange(i, "title", e.target.value)}
                                    />

                                    <div className="p-2 rounded-lg border border-gray-300 text-center font-bold h-12">
                                        {i + 1}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <button
                    type="submit"
                    className="bg-wisdomOrange hover:bg-wisdomDarkOrange text-white p-3 rounded-lg font-bold transition-all"
                >
                    ارسال
                </button>
            </form>
            <Popup
                isOpen={notAvailable}
                onClose={() => setNotAvailable(false)}
                // message={language ? "This system will be available soon" : "هذا النظام سيتم إطلاقه قريباً"}
                message={popupMessage}
                button="حسناً"
                form={false}
            />
        </div >
    );
};

export default WisdomTmsAddTask;